import axios from "axios";
import { Constants } from "../lib/const/constants";
import { encryptPayload } from "../utils/encryption";




export const ticketCreate = async (formData) => {

  //  console.log('form data in',formData);
  return axios.post(Constants.BASE_URL + 'APi-FX-236-CREATE-TICKET', formData, {
    headers: {
      'fx_key': Constants.SUBSCRIPTION_KEY,
    }
  });
};



export const getAllTicket = async (workspace_id) => {
  const encryptedPayload = await encryptPayload({
      workspace_id: workspace_id,
      platform: 'web',
      extraParamValidation: 'trustedfromweb'
    });

  try {
    const response = await axios.post(Constants.BASE_URL + 'APi-FX-235-GET-ALL-TICKETS', encryptedPayload, {
      headers: {
        'fx_key': Constants.SUBSCRIPTION_KEY,
      }
    });
    if (response.status === 200 && response.data.message === "Success") {
      const parsedTickets = JSON.parse(response.data.tickets);
      return parsedTickets;
    } else {
      throw new Error("API did not return success");
    }
  } catch (error) {
    console.error("Error fetching tickets:", error);
    throw error;
  }
};

export const ticketDetails = async (ticket_id) => {
  const encryptedPayload = await encryptPayload({
      ticket_id: ticket_id,
      platform: 'web',
      extraParamValidation: 'trustedfromweb'
    });
  try {
    const response = await axios.post(Constants.BASE_URL + 'APi-FX-238-GET-TICKET-DETAILS', encryptedPayload, {
      headers: {
        'fx_key': Constants.SUBSCRIPTION_KEY,
      }
    });
    //console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching tickets:", error);
    throw error;
  }
};


export const ticketComments = async(ticketId, comment, attachments) => {
  // console.log(ticketId);
  // console.log(comment);
  // console.log(attachments);

  const encryptedPayload = await encryptPayload({ comment: comment, ticket: ticketId, attachments:attachments,platform: 'web',
      extraParamValidation: 'trustedfromweb' });

  try {
    // tickets/18/comment/
    const response = await axios.post(Constants.BASE_URL + 'APi-FX-237-CREATE-COMMENT',
     encryptedPayload, {
      headers: {
        'Content-Type': 'application/json',
        'fx_key': Constants.SUBSCRIPTION_KEY
      }
    });
    // console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error submitting comment:", error);
    throw error;
  }

};


export const currencyRequest = async(formData) =>{
  const encryptedPayload = await encryptPayload(formData);

  try {
    const response = await axios.post(
      Constants.BASE_URL + 'API-FX-193-CONTACTUS',
      encryptedPayload,
      {
        headers: {
          'fx_key': Constants.SUBSCRIPTION_KEY,
        }
      }
    );
    
    console.log('res',response);
    // Optional: check for success message
    if (response.status === 200 && response.data.message === "successfully sent") {
      return response.data;
    } else {
      throw new Error("Currency request failed");
    }
  } catch (error) {
    console.error("Error in currencyRequest:", error);
    throw error;
  }


}

